import { useCallback, useContext, useEffect, useState } from 'react';

import {
  ColSize,
  RowSize,
} from '../../../../../../../../../../../shared/components';
import { FormCoverages } from './components/Form';
import { Tabs } from '@hdi-seguros/web-components.tabs';

import { StepFourFormContext } from '../../../../../StepFour/contexts/StepFourForm';

export const PropertyDataSection = () => {
  const { quotationResponse } = useContext(StepFourFormContext);

  const [activeTab, setActiveTab] = useState<any>(
    quotationResponse?.componentes[0].nroDeComponente
  );
  const [tabs, setTabs] = useState<Array<any>>([]);

  const createTabs = useCallback(() => {
    const newTabs = quotationResponse?.componentes?.map(
      (commerceComponent, index: number) => ({
        children: (
          <FormCoverages
            commerceComponent={commerceComponent}
            key={`${commerceComponent.codigoPostal}-${index}`}
          />
        ),
        closable: false,
        forceRender: true,
        key: commerceComponent.nroDeComponente,
        label: `Integral de Comercio ${commerceComponent.nroDeComponente}`,
      })
    );

    setTabs(newTabs ?? []);
  }, [quotationResponse, setTabs]);

  const handlePressTab = (activeTab: string) => setActiveTab(activeTab);

  useEffect(() => {
    createTabs();
  }, [createTabs]);

  return (
    <RowSize className='mt-1'>
      <ColSize size={100}>
        <Tabs
          activeKey={activeTab}
          handlePressTab={handlePressTab}
          items={tabs}
        />
      </ColSize>
    </RowSize>
  );
};
